// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"5e9f43f5","316":"e3e10413","441":"c1ea058e","450":"6aea557a","712":"8763ac64","896":"f9d00939","970":"d7855fcd"}[chunkId] + ".chunk.js";
};